/**
 * Web stub for react-native-keyboard-controller
 * Provides stubs for keyboard-related functionality on web
 */
import React from 'react';

// KeyboardAwareScrollView - just a regular div wrapper
export const KeyboardAwareScrollView = React.forwardRef((props: any, ref: any) => {
  const { children, style, ...rest } = props;
  return (
    <div
      ref={ref}
      style={{
        overflow: 'auto',
        ...style,
      }}
      {...rest}
    >
      {children}
    </div>
  );
});

KeyboardAwareScrollView.displayName = 'KeyboardAwareScrollView';

// KeyboardGestureArea - just render children
export const KeyboardGestureArea = ({ children }: any) => {
  return <>{children}</>;
};

// useKeyboardHandler hook
export const useKeyboardHandler = (handlers: any) => {
  React.useEffect(() => {
    // No-op on web
  }, []);
};

// KeyboardProvider - just render children
export const KeyboardProvider = ({ children }: any) => {
  return <>{children}</>;
};

// useKeyboardAnimation hook
export const useKeyboardAnimation = () => {
  return {
    height: React.useRef({ value: 0 }).current,
  };
};

// Default export
export default {
  KeyboardAwareScrollView,
  KeyboardGestureArea,
  useKeyboardHandler,
  KeyboardProvider,
  useKeyboardAnimation,
};
